import React, { useState } from 'react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from '../../components/ui/Table';
import { Badge } from '../../components/ui/Badge';
import { CheckSquare, FileText, ArrowRight, Package, Download, Mail, Printer, CheckCircle } from 'lucide-react';
export function POConsolidation() {
  const [step, setStep] = useState(1);
  const [selectedOrders, setSelectedOrders] = useState<string[]>(['ORD-001', 'ORD-002']);
  const orders = [{
    id: 'ORD-001',
    coop: 'Koperasi Maju Jaya',
    date: '10 Okt 2023',
    items: 12,
    total: 4500000,
    status: 'pending'
  }, {
    id: 'ORD-002',
    coop: 'Koperasi Sejahtera',
    date: '10 Okt 2023',
    items: 8,
    total: 2100000,
    status: 'pending'
  }, {
    id: 'ORD-003',
    coop: 'Tani Makmur',
    date: '11 Okt 2023',
    items: 24,
    total: 8900000,
    status: 'pending'
  }, {
    id: 'ORD-004',
    coop: 'Desa Mandiri',
    date: '11 Okt 2023',
    items: 15,
    total: 5200000,
    status: 'pending'
  }];
  const groupedProducts = [{
    name: 'Indomie Goreng Special',
    sku: 'SKU-IM-001',
    totalQty: 150,
    moq: 100,
    unit: 'Karton',
    supplier: 'Indofood',
    status: 'met'
  }, {
    name: 'Aqua Galon 19L',
    sku: 'SKU-AQ-002',
    totalQty: 45,
    moq: 50,
    unit: 'Galon',
    supplier: 'Danone',
    status: 'not_met'
  }, {
    name: 'Beras Ramos 5kg',
    sku: 'SKU-BR-005',
    totalQty: 500,
    moq: 200,
    unit: 'Karung',
    supplier: 'PT Beras Ramos',
    status: 'met'
  }];
  const toggleOrder = (id: string) => {
    setSelectedOrders(prev => prev.includes(id) ? prev.filter(o => o !== id) : [...prev, id]);
  };
  return <div className="space-y-6" data-id="element-940">
      {/* Header */}
      <div data-id="element-941">
        <h2 className="text-2xl font-bold text-slate-900" data-id="element-942">
          Konsolidasi Purchase Order
        </h2>
        <p className="text-sm text-slate-500 mt-1" data-id="element-943">
          Gabungkan pesanan koperasi menjadi PO supplier
        </p>
      </div>

      {/* Progress Stepper */}
      <div className="flex items-center justify-center mb-8" data-id="element-944">
        <div className={`flex items-center gap-2 ${step >= 1 ? 'text-blue-600 font-bold' : 'text-slate-400'}`} data-id="element-945">
          <div className={`w-10 h-10 rounded-full flex items-center justify-center border-2 ${step >= 1 ? 'border-blue-600 bg-blue-50' : 'border-slate-300'}`} data-id="element-946">
            1
          </div>
          <span className="text-sm" data-id="element-947">Pilih Pesanan</span>
        </div>
        <div className="w-20 h-0.5 bg-slate-200 mx-4" data-id="element-948" />
        <div className={`flex items-center gap-2 ${step >= 2 ? 'text-blue-600 font-bold' : 'text-slate-400'}`} data-id="element-949">
          <div className={`w-10 h-10 rounded-full flex items-center justify-center border-2 ${step >= 2 ? 'border-blue-600 bg-blue-50' : 'border-slate-300'}`} data-id="element-950">
            2
          </div>
          <span className="text-sm" data-id="element-951">Review Grouping</span>
        </div>
        <div className="w-20 h-0.5 bg-slate-200 mx-4" data-id="element-952" />
        <div className={`flex items-center gap-2 ${step >= 3 ? 'text-blue-600 font-bold' : 'text-slate-400'}`} data-id="element-953">
          <div className={`w-10 h-10 rounded-full flex items-center justify-center border-2 ${step >= 3 ? 'border-blue-600 bg-blue-50' : 'border-slate-300'}`} data-id="element-954">
            3
          </div>
          <span className="text-sm" data-id="element-955">Generate PO</span>
        </div>
      </div>

      {step === 1 && <div className="space-y-4" data-id="element-956">
          <div className="flex justify-between items-center" data-id="element-957">
            <div data-id="element-958">
              <h3 className="font-bold text-lg text-slate-900" data-id="element-959">
                Pesanan Menunggu Konsolidasi
              </h3>
              <p className="text-sm text-slate-500 mt-1" data-id="element-960">
                {selectedOrders.length} pesanan dipilih
              </p>
            </div>
            <Button variant="primary" onClick={() => setStep(2)} icon={<ArrowRight className="w-4 h-4" data-id="element-962" />} disabled={selectedOrders.length === 0} data-id="element-961">
              Proses Pesanan Terpilih
            </Button>
          </div>

          <Table data-id="element-963">
            <TableHeader data-id="element-964">
              <TableRow data-id="element-965">
                <TableHead className="w-12" data-id="element-966">
                  <input type="checkbox" className="rounded" data-id="element-967" />
                </TableHead>
                <TableHead data-id="element-968">ID Pesanan</TableHead>
                <TableHead data-id="element-969">Koperasi</TableHead>
                <TableHead data-id="element-970">Tanggal</TableHead>
                <TableHead data-id="element-971">Jumlah Item</TableHead>
                <TableHead data-id="element-972">Total Nilai</TableHead>
                <TableHead data-id="element-973">Status</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody data-id="element-974">
              {orders.map(order => <TableRow key={order.id} className={selectedOrders.includes(order.id) ? 'bg-blue-50' : ''} data-id="element-975">
                  <TableCell data-id="element-976">
                    <input type="checkbox" className="rounded" checked={selectedOrders.includes(order.id)} onChange={() => toggleOrder(order.id)} data-id="element-977" />
                  </TableCell>
                  <TableCell className="font-medium font-mono text-sm" data-id="element-978">
                    {order.id}
                  </TableCell>
                  <TableCell className="font-medium" data-id="element-979">{order.coop}</TableCell>
                  <TableCell className="text-slate-600" data-id="element-980">{order.date}</TableCell>
                  <TableCell className="text-slate-600" data-id="element-981">
                    {order.items} SKU
                  </TableCell>
                  <TableCell className="font-bold text-blue-600" data-id="element-982">
                    Rp {order.total.toLocaleString('id-ID')}
                  </TableCell>
                  <TableCell data-id="element-983">
                    <Badge variant="warning" data-id="element-984">Menunggu</Badge>
                  </TableCell>
                </TableRow>)}
            </TableBody>
          </Table>
        </div>}

      {step === 2 && <div className="space-y-6" data-id="element-985">
          <div className="flex justify-between items-center" data-id="element-986">
            <div data-id="element-987">
              <h3 className="font-bold text-lg text-slate-900" data-id="element-988">
                Grouping Produk & Cek MOQ
              </h3>
              <p className="text-sm text-slate-500 mt-1" data-id="element-989">
                Verifikasi minimum order quantity terpenuhi
              </p>
            </div>
            <div className="flex gap-3" data-id="element-990">
              <Button variant="outline" onClick={() => setStep(1)} data-id="element-991">
                Kembali
              </Button>
              <Button variant="primary" onClick={() => setStep(3)} icon={<FileText className="w-4 h-4" data-id="element-993" />} data-id="element-992">
                Generate PO Supplier
              </Button>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-994">
            {groupedProducts.map((product, i) => <Card key={i} className={`p-5 border-l-4 ${product.status === 'met' ? 'border-l-green-500 bg-green-50/50' : 'border-l-red-500 bg-red-50/50'}`} data-id="element-995">
                <div className="flex justify-between items-start mb-3" data-id="element-996">
                  <div className="flex-1" data-id="element-997">
                    <h4 className="font-bold text-slate-900 mb-1" data-id="element-998">
                      {product.name}
                    </h4>
                    <p className="text-xs text-slate-500 font-mono" data-id="element-999">
                      {product.sku}
                    </p>
                    <p className="text-xs text-slate-600 mt-1" data-id="element-1000">
                      Supplier: {product.supplier}
                    </p>
                  </div>
                  <Package className={`w-6 h-6 ${product.status === 'met' ? 'text-green-600' : 'text-red-600'}`} data-id="element-1001" />
                </div>

                <div className="flex justify-between items-end mb-3" data-id="element-1002">
                  <div data-id="element-1003">
                    <p className="text-xs text-slate-500 mb-1" data-id="element-1004">
                      Total Quantity
                    </p>
                    <p className="text-3xl font-bold text-slate-900" data-id="element-1005">
                      {product.totalQty}
                    </p>
                    <p className="text-xs text-slate-500" data-id="element-1006">{product.unit}</p>
                  </div>
                  <div className="text-right" data-id="element-1007">
                    <p className="text-xs text-slate-500 mb-1" data-id="element-1008">Target MOQ</p>
                    <p className={`text-2xl font-bold ${product.status === 'met' ? 'text-green-600' : 'text-red-600'}`} data-id="element-1009">
                      {product.moq}
                    </p>
                    <p className="text-xs text-slate-500" data-id="element-1010">{product.unit}</p>
                  </div>
                </div>

                {product.status === 'not_met' ? <div className="bg-red-100 border border-red-200 text-red-800 text-xs font-bold px-3 py-2 rounded-lg" data-id="element-1011">
                    ⚠️ MOQ belum terpenuhi! Kurang{' '}
                    {product.moq - product.totalQty} {product.unit}
                  </div> : <div className="bg-green-100 border border-green-200 text-green-800 text-xs font-bold px-3 py-2 rounded-lg flex items-center gap-2" data-id="element-1012">
                    <CheckCircle className="w-4 h-4" data-id="element-1013" />
                    MOQ terpenuhi! Siap order ke supplier
                  </div>}
              </Card>)}
          </div>

          {/* Summary */}
          <Card className="p-6 bg-slate-50 border-slate-200" data-id="element-1014">
            <div className="grid grid-cols-3 gap-6" data-id="element-1015">
              <div data-id="element-1016">
                <p className="text-sm text-slate-600 mb-1" data-id="element-1017">Total Produk</p>
                <p className="text-2xl font-bold text-slate-900" data-id="element-1018">
                  {groupedProducts.length} SKU
                </p>
              </div>
              <div data-id="element-1019">
                <p className="text-sm text-slate-600 mb-1" data-id="element-1020">MOQ Terpenuhi</p>
                <p className="text-2xl font-bold text-green-600" data-id="element-1021">
                  {groupedProducts.filter(p => p.status === 'met').length} SKU
                </p>
              </div>
              <div data-id="element-1022">
                <p className="text-sm text-slate-600 mb-1" data-id="element-1023">
                  Total Nilai Estimasi
                </p>
                <p className="text-2xl font-bold text-blue-600" data-id="element-1024">
                  Rp 15.500.000
                </p>
              </div>
            </div>
          </Card>
        </div>}

      {step === 3 && <div className="text-center py-16" data-id="element-1025">
          <div className="w-24 h-24 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg" data-id="element-1026">
            <CheckSquare className="w-12 h-12" data-id="element-1027" />
          </div>
          <h2 className="text-3xl font-bold text-slate-900 mb-3" data-id="element-1028">
            Purchase Order Berhasil Dibuat!
          </h2>
          <p className="text-slate-600 mb-8 text-lg" data-id="element-1029">
            3 PO telah dibuat dan siap dikirim ke supplier
          </p>

          <div className="flex justify-center gap-3 mb-8" data-id="element-1030">
            <Button variant="outline" icon={<Download className="w-4 h-4" data-id="element-1032" />} data-id="element-1031">
              Unduh PDF
            </Button>
            <Button variant="outline" icon={<Printer className="w-4 h-4" data-id="element-1034" />} data-id="element-1033">
              Cetak PO
            </Button>
            <Button variant="primary" icon={<Mail className="w-4 h-4" data-id="element-1036" />} data-id="element-1035">
              Kirim Email ke Supplier
            </Button>
          </div>

          <Card className="max-w-2xl mx-auto p-6 text-left" data-id="element-1037">
            <h3 className="font-bold text-slate-900 mb-4" data-id="element-1038">
              Detail PO yang Dibuat:
            </h3>
            <div className="space-y-3" data-id="element-1039">
              <div className="flex justify-between items-center p-3 bg-slate-50 rounded-lg" data-id="element-1040">
                <div data-id="element-1041">
                  <p className="font-bold text-slate-900" data-id="element-1042">
                    PO-SUP-001 - Indofood
                  </p>
                  <p className="text-sm text-slate-600" data-id="element-1043">
                    Indomie Goreng Special (150 Karton)
                  </p>
                </div>
                <span className="font-bold text-blue-600" data-id="element-1044">Rp 4.650.000</span>
              </div>
              <div className="flex justify-between items-center p-3 bg-slate-50 rounded-lg" data-id="element-1045">
                <div data-id="element-1046">
                  <p className="font-bold text-slate-900" data-id="element-1047">
                    PO-SUP-002 - PT Beras Ramos
                  </p>
                  <p className="text-sm text-slate-600" data-id="element-1048">
                    Beras Ramos 5kg (500 Karung)
                  </p>
                </div>
                <span className="font-bold text-blue-600" data-id="element-1049">Rp 32.500.000</span>
              </div>
            </div>
          </Card>

          <div className="mt-8" data-id="element-1050">
            <Button variant="outline" onClick={() => setStep(1)} data-id="element-1051">
              Proses Pesanan Lainnya
            </Button>
          </div>
        </div>}
    </div>;
}